module.exports = __webpack_public_path__ + "static/banner-three-shape2-08b71cc1e84570434fa7cdf62d3a9e53.png";